/* @generated */

// src/assets/ui-icon/fill/twinkle-2.tsx
import * as React from "react";
var Twinkle2Fill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M19.25 16c-1.21 0-1.75-.54-1.75-1.75v-.75H16v.75c0 1.21-.54 1.75-1.75 1.75h-.75v1.5h.75c1.21 0 1.75.54 1.75 1.75V20h1.5v-.75c0-1.21.54-1.75 1.75-1.75H20V16h-.75ZM16.5 9.5C12.8 9.5 11 7.7 11 4H9.5c0 3.7-1.8 5.5-5.5 5.5V11c3.7 0 5.5 1.8 5.5 5.5H11c0-3.7 1.8-5.5 5.5-5.5V9.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  Twinkle2Fill
};
